import { NgModule } from '@angular/core';
import { CoreCommonModule } from '@core/common.module';
import { LoginRoutingModule } from './login-routing.module';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from 'app/shared/shared.module';
import { LoginFormComponent } from '../../components/login-form/login-form.component';
import { LoginComponent } from './login.component';

@NgModule({
  declarations: [LoginComponent, LoginFormComponent],
  imports: [
    CoreCommonModule,
    LoginRoutingModule,
    TranslateModule,
    SharedModule,
  ],
  providers: [],
})
export class LoginModule {}
